<div class="loginTitle" mat-dialog-title>
    <img [src]="'/'+appConfig.appBaseName + 'assets/images/svg/login/' + appConfig.projectLogo" alt="AIRA Matrix"
        aria-label="AIRA Matrix" class="center" />
</div>
<ng-container *ngIf="!IschangePassword &&  !isforgetPassword">
    <div class="loginContent" mat-dialog-content>
        <mat-form-field class="loginCredentialFields loginEmailId" appearance="outline">
            <input type="email" matInput [(ngModel)]="userEmailId" (keyup.enter)="validateLogin(false)"
                placeholder="Email Id" [readonly]="data.isAccessTokenExpired"  [ngClass]="{'disabledUserField':data.isAccessTokenExpired}">
        </mat-form-field>

        <mat-form-field class="loginCredentialFields loginPassword" appearance="outline">
            <input [type]="hide ? 'password' : 'text'" matInput [(ngModel)]="userPassword"
                (keyup.enter)="validateLogin(false)" placeholder="Password">
            <mat-icon matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>
        <div class="invalidCreds" *ngIf="invalidUserCredentials">Please enter valid credentials</div>
    </div>
</ng-container>

<ng-container *ngIf="isforgetPassword">
    <div class="passCodeRecoveryHeader">
        <div>Account recovery</div>
        <!-- <mat-icon (click)="closeForgetPassword()" class="cursorPointer">close</mat-icon> -->
    </div>
    <div class="loginContent" mat-dialog-content>
        <ng-container *ngIf="!isOtpSend">


            <mat-form-field class="loginCredentialFields loginEmailId" appearance="outline">
                <input type="email" matInput [(ngModel)]="forgetPasswordObj.emailId" placeholder="Email Id" #emailInput
                    [disabled]="data.isAccessTokenExpired">
                <mat-icon matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide">
                    {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>

            <!-- <div class="invalidCreds" *ngIf="validate()"> Invalid Email</div> -->

        </ng-container>

        <ng-container *ngIf="isCodeVerified">
            <mat-form-field class="loginCredentialFields loginEmailId" appearance="outline">
                <input [type]="hideNwPassword ? 'password' : 'text'" matInput
                    [(ngModel)]="forgetPasswordObj.newPassword" placeholder="New Password"
                    [disabled]="data.isAccessTokenExpired">
                <mat-icon matSuffix (click)="hideNwPassword = !hideNwPassword" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide">
                    {{hideNwPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>

            <mat-form-field class="loginCredentialFields loginEmailId" appearance="outline">
                <input [type]="hideConfirmPassword ? 'password' : 'text'" matInput
                    [(ngModel)]="forgetPasswordObj.confirmedPassword" placeholder="Confirm Password"
                    [disabled]="data.isAccessTokenExpired">
                <mat-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    {{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
        </ng-container>

        <ng-container *ngIf="isOtpSend && !isCodeVerified">
            <mat-form-field class="loginCredentialFields loginEmailId" appearance="outline">
                <input matInput [(ngModel)]="forgetPasswordObj.verificationCode" placeholder="Enter verification code"
                    [disabled]="data.isAccessTokenExpired">
            </mat-form-field>
        </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="IschangePassword">
    <div class="loginContent" mat-dialog-content>
        <mat-form-field class="loginCredentialFields loginEmailId" appearance="outline">
            <input [type]="hideOldPassword ? 'password' : 'text'" matInput [(ngModel)]="changePasswordObj.oldPassword"
                placeholder="Old Password" [disabled]="data.isAccessTokenExpired">
            <mat-icon matSuffix (click)="hideOldPassword = !hideOldPassword" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                {{hideOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>

        <mat-form-field class="loginCredentialFields loginEmailId" appearance="outline">
            <input [type]="hideNwPassword ? 'password' : 'text'" matInput [(ngModel)]="changePasswordObj.newPassword"
                placeholder="New Password" [disabled]="data.isAccessTokenExpired">
            <mat-icon matSuffix (click)="hideNwPassword = !hideNwPassword" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                {{hideNwPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>

        <mat-form-field class="loginCredentialFields loginEmailId" appearance="outline">
            <input [type]="hideConfirmPassword ? 'password' : 'text'" matInput
                [(ngModel)]="changePasswordObj.confirmedPassword" placeholder="Confirm Password"
                [disabled]="data.isAccessTokenExpired">
            <mat-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                {{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>
    </div>
</ng-container>



<ng-container *ngIf="!isforgetPassword && !IschangePassword">
    <div class="loginAction" mat-dialog-actions [class.inlineBtrnGrp]="data.isAccessTokenExpired">
        <button *ngIf="data.isAccessTokenExpired" class="btnLoginCancel" mat-raised-button color="default"
            (click)="CancelLogin()">Cancel</button>
        <button class="btnLogin" mat-raised-button color="primary" (click)="validateLogin(false)"
            *ngIf="!isforgetPassword">Login</button>
        <!-- <button class="btnLogin" mat-raised-button color="primary" (click)="validateLogin()" *ngIf="isforgetPassword" (click)="sendOtp()">Send otp</button> -->
    </div>
</ng-container>

<div class="loginAction">
    <ng-container *ngIf="isforgetPassword">
        <ng-container *ngIf="!isCodeVerified">
            <ng-container *ngIf=" !showLoader &&!isOtpSend">
                <button class="btnLogin" mat-raised-button color="primary" (click)="sendEmail()"
                    [disabled]=" !forgetPasswordObj.emailId">Send verification code</button>
            </ng-container>
            <ng-container *ngIf="!isOtpSend && showLoader">
                <button class="btnLogin" mat-raised-button color="primary" [disabled]="true">Sending mail ...</button>
            </ng-container>
            <button class="btnLogin" mat-raised-button color="primary"
                *ngIf="isforgetPassword && isOtpSend && !isCodeVerified" (click)="verifyCode()"
                [disabled]=" !forgetPasswordObj.verificationCode">Submit verification code</button>
        </ng-container>

        <button class="btnLogin" mat-raised-button color="primary" *ngIf=" isCodeVerified"
            (click)="setNewPassword()">Submit</button>
        <!-- <button class="btnLogin" mat-raised-button color="primary" *ngIf="isforgetPassword" (click)="sendOtp()"></button> -->
        <button class="cancelActionBtn" (click)="closeForgetPassword()" mat-raised-button>Cancel</button>
    </ng-container>
    <ng-container *ngIf="IschangePassword">
        <button class="btnLogin" mat-raised-button color="primary" (click)="resetPassword()">Change Password</button>
        <button class="cancelActionBtn" (click)="cancelChangePassword()" mat-raised-button>Cancel</button>

    </ng-container>
</div>

<ng-container *ngIf="!isforgetPassword && !IschangePassword && !data.isAccessTokenExpired">
    <div class="forgotpwd">
        <span (click)="enableForgetPassword()">Forget Password?</span>
    </div>
</ng-container>